import axios from "axios"
import { useEffect, useState } from "react"
import { ArtBlocksChainId } from "contractConfig"
import { getArtBlocksTokenUrl, isArtBlocksChainId } from "utils/artBlocksUrls"
import { NftTokenMetadata } from "utils/tokenMetadata"

const useTokenMetadata = (
  contractAddress?: string,
  tokenId?: string,
  chainId?: number | string | null,
  enabled = true
) => {
  const [data, setData] = useState<NftTokenMetadata | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!enabled || !contractAddress || !tokenId || !isArtBlocksChainId(chainId)) {
      setData(null)
      setLoading(false)
      return
    }

    let cancelled = false
    setLoading(true)
    setError(false)

    const url = getArtBlocksTokenUrl({
      chainId: Number(chainId) as ArtBlocksChainId,
      contractAddress,
      tokenId,
    })

    axios
      .get<NftTokenMetadata>(url)
      .then((response) => {
        if (!cancelled) setData(response.data)
      })
      .catch(() => {
        if (!cancelled) setError(true)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [chainId, contractAddress, enabled, tokenId])

  return { data, loading, error }
}

export default useTokenMetadata
